import React from 'react';

import AnalyticsBarChart from './AnalyticsBarChart';
import { createBarChartDataset } from 'helpers/analytics';

const SubscriptionsAnalytics = ({ subscriptionsAnalytics }) => {
  if (!subscriptionsAnalytics || !subscriptionsAnalytics.length) {
    return null;
  }

  const allDataset = createBarChartDataset(
    subscriptionsAnalytics,
    'type',
    'ALL',
  );
  const b2bDataset = createBarChartDataset(
    subscriptionsAnalytics,
    'type',
    'B2B',
  );
  const b2cDataset = createBarChartDataset(
    subscriptionsAnalytics,
    'type',
    'B2C',
  );

  return (
    <div>
      <div style={{ display: 'flex', marginBottom: '40px' }}>
        <AnalyticsBarChart
          dataset={allDataset}
          name="All Subscriptions"
          fill="#0570A6"
        />
        <AnalyticsBarChart
          dataset={b2bDataset}
          name="B2B Subscriptions"
          fill="#0489A8"
        />
      </div>
      <AnalyticsBarChart
        dataset={b2cDataset}
        name="B2C Subscriptions"
        fill="#74A9BB"
        width="50%"
      />
    </div>
  );
};

export default SubscriptionsAnalytics;
